<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-3 header">
    <span class="material-icons">book</span> Physical File
  </div>
  <mat-horizontal-stepper #stepper>
    <mat-step [stepControl]="requiredStepForm">
      <ng-template matStepLabel>
        <i class="fa fa-check-circle"></i> Primary
      </ng-template>
      <div class="stepper-container">
        <mat-card class="example-card">
          <form [formGroup]="requiredStepForm" class="form-container">
            <div class="input-container">
              <mat-form-field class="input">
                <input matInput placeholder="{{pfObj['pf_name']['name']}}" formControlName="pf_name">
                <mat-icon *ngIf="pfObj['pf_name']['description']" matSuffix color="primary"
                  matTooltip="{{pfObj['pf_name']['description']}}">
                  info
                </mat-icon>
                <mat-error *ngIf="requiredStepForm.get('pf_name').hasError('required')">required</mat-error>
              </mat-form-field>
            </div>
            <div class="input-container">
              <mat-form-field class="input">
                <input matInput placeholder="{{pfObj['di_bus_nm']['name']}}" formControlName="di_bus_nm">
                <mat-icon *ngIf="pfObj['di_bus_nm']['description']" matSuffix color="primary"
                  matTooltip="{{pfObj['di_bus_nm']['description']}}">
                  info
                </mat-icon>
                <mat-error *ngIf="requiredStepForm.get('di_bus_nm').hasError('required')">required</mat-error>
              </mat-form-field>
            </div>
            <div class="input-container">
              <mat-form-field class="input">
                <!-- <input matInput placeholder="{{pfObj['di_desc']['name']}}" formControlName="di_desc"> -->
                <textarea matInput placeholder="{{pfObj['di_desc']['name']}}" formControlName="di_desc"
                rows="3"></textarea>
                <mat-icon *ngIf="pfObj['di_desc']['description']" matSuffix color="primary"
                  matTooltip="{{pfObj['di_desc']['description']}}">
                  info
                </mat-icon>
                <mat-error *ngIf="requiredStepForm.get('di_desc').hasError('required')">required</mat-error>
              </mat-form-field>
            </div>
            <div class="input-container">
              <mat-form-field class="input">
                <mat-select placeholder="{{pfObj['default_ds']['name']}}" formControlName="default_ds">
                  <mat-option *ngFor="let item of dsarr" [value]="item.di_tech_nm"  id="dsselect">{{item.di_bus_nm}}</mat-option>
                </mat-select>
                <mat-icon *ngIf="pfObj['default_ds']['description']" matSuffix color="primary"
                  matTooltip="{{pfObj['default_ds']['description']}}">
                  info
                </mat-icon>

                <mat-error *ngIf="requiredStepForm.get('default_ds').hasError('required')">Default DS is required
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </mat-card>
      </div>
      <div class="button-container">
        <button mat-button matStepperPrevious color="warn" (click)="backtolist()">Cancel</button>
        <button mat-button color="primary" (click)="gotoAdditonal(stepper)">Next</button>
      </div>
      <div>
      </div>
    </mat-step>
    <mat-step [stepControl]="requiredStepForm">
      <ng-template matStepLabel>
        <i class="fa fa-cogs"></i> Additional Details
      </ng-template>
      <form [formGroup]="requiredStepForm" class="form-container">
        <mat-horizontal-stepper #innerStepper>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-file"></i> File Details</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-select placeholder="{{pfObj['pf_tcd']['name']}}" formControlName="pf_tcd">
                      <mat-option *ngFor="let item of clArr" [value]="item.cl_cd">{{item.cl_val}}</mat-option>
                    </mat-select>
                    <mat-icon *ngIf="pfObj['pf_tcd']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['pf_tcd']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('pf_tcd').hasError('required')">Default DS is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-select placeholder="{{pfObj['pf_path']['name']}}" formControlName="pf_path">
                      <mat-option *ngFor="let item of apparr" [value]="item.cl_cd">{{item.cl_val}}</mat-option>
                    </mat-select>
                    <!-- <span class="question-mark" matTooltip="{{ pfObj['pf_name']['description']}}">?</span> -->

                    <mat-icon *ngIf="pfObj['pf_path']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['pf_path']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('pf_path').hasError('required')">required</mat-error>
                  </mat-form-field>
                </div>
                <div class="input-container">
                  <mat-form-field class="input">
                    <input matInput placeholder="{{pfObj['di_cd']['name']}}" formControlName="di_cd">
                    <!-- <span class="question-mark" matTooltip="{{ pfObj['pf_name']['description']}}">?</span> -->

                    <mat-icon *ngIf="pfObj['di_cd']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['di_cd']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('di_cd').hasError('required')">required</mat-error>
                  </mat-form-field>
                </div>

                <!-- <div class="input-container">
                  <mat-form-field class="input">
                    <input matInput placeholder="{{pfObj['di_bus_nm']['name']}}" formControlName="di_bus_nm">
               

                    <mat-icon *ngIf="pfObj['di_bus_nm']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['di_bus_nm']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('di_bus_nm').hasError('required')">required</mat-error>
                  </mat-form-field>
                </div> -->

                <!-- <div class="input-container">
                  <mat-form-field class="input">
                    <input matInput placeholder="{{pfObj['di_tech_nm']['name']}}" formControlName="di_tech_nm">
                  

                    <mat-icon *ngIf="pfObj['di_tech_nm']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['di_tech_nm']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('di_tech_nm').hasError('required')">required</mat-error>
                  </mat-form-field>
                </div> -->

                <!-- <div class="input-container">
                  <mat-form-field class="input">
                    <mat-select placeholder="{{pfObj['charset']['name']}}" formControlName="charset">
                      <mat-option *ngFor="let item of charset" [value]="item.cl_cd">{{item.cl_val}}</mat-option>
                    </mat-select>
                    <mat-icon *ngIf="pfObj['charset']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['charset']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('charset').hasError('required')">Default DS is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-select placeholder="{{pfObj['collating_seq']['name']}}" formControlName="collating_seq">
                      <mat-option *ngFor="let item of collating_seq" [value]="item.cl_cd">{{item.cl_val}}</mat-option>
                    </mat-select>
                    <mat-icon *ngIf="pfObj['collating_seq']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['collating_seq']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('collating_seq').hasError('required')">Default DS is required
                    </mat-error>
                  </mat-form-field>
                </div> -->
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button color="warn" (click)="goBackToFirstStepper()">Back</button>
              <button mat-button matStepperNext color="primary">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-key"></i> Keys</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <mat-vertical-stepper #verticalStepper>

                  <mat-step>
                    <ng-template matStepLabel>Primary Key</ng-template>
                    <div class="example-container">
                      <div class="row-container">
                      </div>
                      <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                        <thead>
                          <tr class="Table-header">
                            <td style="width: 20%;">Seq No.</td>

                            <td style="width: 60%;">Select Term/Terms</td>

                            <!-- <td style="width: 20%;">Action</td> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of primaryKeyData;let i=index">
                            <td style="width: 40%;">
                              {{i+1}}
                            </td>
                            <td style="width: 40%;">
                              <!-- <mat-form-field>
                                          <mat-label>Select</mat-label>
                                          <mat-select placeholder="select Terms" class="font">
                                            <mat-option *ngFor="let item of termarr" [value]="item.di_tech_nm">{{item.di_tech_nm}}</mat-option>
                                          </mat-select>
                                        </mat-form-field> -->

                              <ng-select placeholder="Select Terms" [multiple]="true" [(ngModel)]="item['pk_keys']"
                                [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let item of termarr" [value]="item.di_tech_nm">{{item.di_tech_nm}}
                                </ng-option>
                              </ng-select>
                            </td>
                            <!-- <td style="width: 20%;">
                              <mat-icon style="color: red;" (click)="deleteRecord(item)">delete</mat-icon>
                              &nbsp;

                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </mat-step>
                  <br>

                  <mat-step>
                    <ng-template matStepLabel>Unique Key</ng-template>

                    <div class="example-container">
                      <div class="row-container">


                        <mat-icon class="right-content" style="color:rgb(0, 119, 128) ;" (click)="addNewRecord()">add
                        </mat-icon>
                      </div>
                      <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                        <thead>
                          <tr class="Table-header">
                            <td style="width: 20%;">Seq No.</td>

                            <td style="width: 60%;">Select Term/Terms</td>

                            <td style="width: 20%;">Action</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of uniqueKeyData;let i=index">
                            <td style="width: 40%;">
                              {{i+1}}
                            </td>
                            <td style="width: 40%;">


                              <ng-select placeholder="Select Terms" [multiple]="true" [(ngModel)]="item['idx_keys']"
                                [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let item of termarr" [value]="item.di_tech_nm"  id="unqarr">{{item.di_tech_nm}}
                                </ng-option>
                              </ng-select>
                            </td>
                            <td style="width: 20%;">
                              <mat-icon style="color: red;" (click)="deleteuniRecord(item)">delete</mat-icon>
                              &nbsp;

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </mat-step>
                  <mat-step>
                    <ng-template matStepLabel>Index</ng-template>

                    <div class="example-container">
                      <div class="row-container">


                        <mat-icon class="right-content" style="color:rgb(0, 119, 128) ;" (click)="addNewindexRecord()">
                          add
                        </mat-icon>
                      </div>
                      <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                        <thead>
                          <tr class="Table-header">
                            <td style="width: 20%;">Seq No.</td>

                            <td style="width: 60%;">Select Term/Terms</td>

                            <td style="width: 20%;">Action</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of indexData;let i=index">
                            <td style="width: 40%;">
                              {{i+1}}
                            </td>
                            <td style="width: 40%;">


                              <ng-select placeholder="Select Terms" [multiple]="true" [(ngModel)]="item['idx_keys']"
                                [ngModelOptions]="{standalone: true}">
                                <ng-option *ngFor="let item of termarr" [value]="item.di_tech_nm">{{item.di_tech_nm}}
                                </ng-option>
                              </ng-select>
                            </td>
                            <td style="width: 20%;">
                              <mat-icon style="color: red;" (click)="deleteinRecord(item)">delete</mat-icon>
                              &nbsp;

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </mat-step>
                </mat-vertical-stepper>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-check"></i> Validations</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <div class="row-container">
                  <mat-icon class="right-content" style="color:rgb(0, 119, 128) ;" (click)="addvalidations()">
                    add
                  </mat-icon>
                </div>
                <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                  <thead>
                    <tr class="Table-header">
                      <td style="width: 40%;">Operation Name</td>

                      <td style="width: 40%;">term</td>

                      <td style="width: 20%;">Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor=" let hook of validations;let i=index">
                      <td style="width: 40%;">
                        <mat-form-field class="input">
                          <mat-select placeholder="Select Custom Validation Operation Name"
                            [(ngModel)]="hook['operator']" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let item of opr_arr" [value]="item.code">{{item.value}}</mat-option>


                          </mat-select>

                          <mat-icon matSuffix color="primary" matTooltip="Select Custom Validation Operation Name">
                            info
                          </mat-icon>
                        </mat-form-field>
                      </td>
                      <td style="width: 40%;">
                        <mat-form-field class="input">
                          <mat-select placeholder="Which term needs this validation? "
                            [(ngModel)]="hook['operands'][0]['const']" [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let item of termarr" [value]="item.di_tech_nm">{{item.di_tech_nm}}
                            </mat-option>
                          </mat-select>

                          <mat-icon matSuffix color="primary" matTooltip="Which term needs this validation? ">
                            info
                          </mat-icon>
                        </mat-form-field>
                      </td>
                      <td style="width: 20%;">
                        <button mat-icon-button color="warn" (click)="deletevalidations(i)">
                          <mat-icon>delete</mat-icon>
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>
                <br>

              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>

          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-cogs"></i> Hooks</ng-template>

            <div class="stepper-container">
              <mat-card class="example-card1">


                <div class="row-container">


                  <mat-icon class="right-content" style="color:rgb(0, 119, 128) ;" (click)="addHook()">
                    add
                  </mat-icon>
                </div>


                <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                  <thead>
                    <tr class="Table-header">
                      <td style="width: 40%;">Hook Name</td>

                      <td style="width: 40%;">Value</td>

                      <td style="width: 20%;">Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor=" let hook of rows;let i=index">
                      <td style="width: 40%;">
                        <mat-form-field class="input">
                          <mat-label>Hook Name</mat-label>
                          <mat-select placeholder="Select Hook Name" [(ngModel)]="hook['var']['name']"
                            [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let item of hookNames" [value]="item.value">{{ item.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td style="width: 40%;">
                        <mat-form-field class="input">
                          <mat-label>Value Name</mat-label>
                          <mat-select placeholder="Select Value" [(ngModel)]="hook['value']['name']"
                            [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let option of valueOptions" [value]="option">{{ option }}</mat-option>
                          </mat-select>
                          <mat-icon matSuffix color="primary" matTooltip="Select Value">info</mat-icon>
                        </mat-form-field>
                      </td>
                      <td style="width: 20%;">
                        <button mat-icon-button color="warn" (click)="deleteHook(i)">
                          <mat-icon>delete</mat-icon>
                        </button>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>
              <button mat-button matStepperNext color="primary">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-comment"></i> Comment</ng-template>

            <div class="stepper-container">
              <mat-card class="example-card1">
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-label>Logical Record Type</mat-label>
                    <mat-select placeholder="" class="font" formControlName="lr_type">
                      <mat-option *ngFor="let item of lr_typearr" [value]="item.code">{{item.value}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="requiredStepForm.get('lr_type').value=='REFERENCE'">

                  <div class="input-container">
                    <mat-form-field class="input">
                      <mat-label>History Type</mat-label>
                      <mat-select placeholder="" class="font" formControlName="lr_hist">
                        <mat-option *ngFor="let item of histarr" [value]="item.code">{{item.code}}-{{item.value}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
                <div class="input-container">
                  <mat-form-field class="input">
                    <textarea matInput placeholder="{{pfObj['comment']['name']}}" formControlName="comment"
                      rows="9"></textarea>
                    <mat-icon *ngIf="pfObj['comment']['description']" matSuffix color="primary"
                      matTooltip="{{pfObj['comment']['description']}}">
                      info
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>
              <!-- <button mat-button matStepperNext (click)="saveInnerStep(innerStepper)" color="primary"
                *ngIf="mode!='view'">Submit</button> -->

              <button mat-button color="primary" *ngIf="mode=='create'"
                (click)="saveInnerStep(innerStepper)">Submit</button>
              <button mat-button color="primary" *ngIf="mode=='update'"
                (click)="saveInnerStep(innerStepper)">Update</button>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </form>
      <div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
